import { motion } from 'framer-motion';
import Badge from './Badge';

function AccreditationGrid({ certifications }) {
  const colorMap = {
    primary: 'from-primary-500 to-primary-600',
    secondary: 'from-secondary-500 to-secondary-600',
  };

  // Items to hide (CSS hide, not remove from code)
  const hiddenIds = ['cpcb', 'kspcb'];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {certifications.map((cert, index) => {
        const isHidden = hiddenIds.includes(cert.id);
        return (
          <motion.div
            key={cert.id}
            className={`bg-white border border-accent-200 rounded-lg p-5 md:p-6 hover:border-primary-300 hover:shadow-sm transition-all duration-200 ${
              isHidden ? 'hidden' : ''
            }`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ y: -4, borderColor: 'rgb(59, 130, 246)', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}
          >
            <div className={`w-12 h-12 rounded-md bg-gradient-to-br ${colorMap[cert.color]} flex items-center justify-center text-2xl mb-4 border border-accent-200`}>
              {cert.icon}
            </div>
            <h3 className="text-lg font-semibold text-accent-900 mb-1.5 leading-tight">
              {cert.title}
            </h3>
            <Badge variant={cert.color} size="sm" className="mb-3 inline-block text-xs">
              {cert.subtitle}
            </Badge>
            <p className="text-xs md:text-sm text-accent-600 mb-4 leading-relaxed min-h-[2.5rem]">
              {cert.description}
            </p>
            {cert.benefits && cert.benefits.length > 0 && (
              <ul className="space-y-2 border-t border-accent-100 pt-4">
                {cert.benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start text-xs md:text-sm text-accent-700">
                    <svg className="w-3.5 h-3.5 text-primary-600 mr-2 flex-shrink-0 mt-0.5" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="leading-snug">{benefit}</span>
                  </li>
                ))}
              </ul>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}

export default AccreditationGrid;